'use client';

import React from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';

import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {GiftThisCourse} from '../gift-this-course';
import {MarketplaceSocialShareButton} from '../share/marketplace-social-share-button.react-component';
import styles from './clp-icon-secondary-actions.module.scss';

export interface ClpIconSecondaryActionProps {
    className?: string;
}

/**
 * ClpIconSecondaryActions component renders secondary action buttons for course landing page
 * including social share and gift course buttons.
 *
 * This is a variation on the CLPSecondaryActions component, which renders an alternate layout which replaces certain buttons
 * with icon variants.
 */
export const ClpIconSecondaryActions = observer(function ClpIconSecondaryActions({
    className,
}: ClpIconSecondaryActionProps) {
    const course = useClpCourse();

    return (
        <div className={classNames(styles['secondary-action-container'], className)}>
            <span className={styles['icon-actions']}>
                <GiftThisCourse onlyIcon />
                <MarketplaceSocialShareButton
                    shareableObject={{
                        ...course,
                        is_private: false,
                    }}
                    size={'large'}
                    onlyIcon
                    sourceUrl={course.urlCourseLanding || ''}
                    context="clp"
                    className="ud-link-underline ud-link-neutral"
                    load={() =>
                        import('../share/marketplace-social-share-content.react-component').then(
                            ({MarketplaceSocialShareContent}) => ({
                                default: MarketplaceSocialShareContent,
                            }),
                        )
                    }
                />
            </span>
        </div>
    );
});
